// extracted by mini-css-extract-plugin
export default {"title":"Q7eJ1fBw9Oa40QZ6tllQ"};